import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';

export const SEGMENT_CREATED_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'segment-created',
  priority: 1,
  predicate: ({ change }) =>
    change.changeType === 'ADD' &&
    change.fieldPath === '/' &&
    change.fieldType === 'confidence.flags.admin.v1.Segment',
  title: () => 'Created segment',
  render: () => null,
});
